import React from 'react'

interface IStepperProps {
  activeClassName?: string
  className?: string
  currentStep: number
  steps: number
  stepperDotClassName?: string
  stepperLineClassName?: string
}

const Stepper = ({
  activeClassName = '',
  className = '',
  currentStep,
  steps,
  stepperDotClassName = '',
  stepperLineClassName = ''
}: IStepperProps) => {
  return (
    <div className={`stepper-container ${className}`}>
      {Array.from({ length: steps }).map((_, index) => (
        <React.Fragment key={index}>
          <div
            className={`${stepperDotClassName || 'stepper-dot'} ${
              index + 1 <= currentStep ? activeClassName || 'active' : ''
            }`}
          />
          {index < steps - 1 && (
            <div
              className={`${stepperLineClassName || 'stepper-line'} ${
                index + 1 < currentStep ? activeClassName || 'active' : ''
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  )
}

export default Stepper



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/common/Stepper.tsx